'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Tooltip_module = require('./Tooltip.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Tooltip = _ref => {
  let {
    title,
    s,
    children
  } = _ref;
  const [tooltipElId] = React.useState(`tooltip-${Math.random().toString(36).substring(2)}`);

  // Clicking the tooltip itself and its children should not treat as a click on
  // its parent. For example, if the tooltip is on a button, clicking a
  // hyperlink inside the tooltip should not trigger the button's click handler.
  const stopPropagation = event => {
    event.stopPropagation();
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: Tooltip_module["default"].tooltipContainer,
    "aria-describedby": tooltipElId
  }, children, /*#__PURE__*/React__default["default"].createElement("span", {
    className: Tooltip_module["default"].tooltipText,
    style: s,
    id: tooltipElId,
    onClick: stopPropagation,
    onKeyDown: stopPropagation,
    role: "button",
    tabIndex: 0
  }, title));
};

exports["default"] = Tooltip;
